<template>
    <div class="content-card-text" :class="contentClasses">
        <content-compiled :html="html"></content-compiled>
    </div>
</template>

<script>
export default {
    name: 'ContentCardText',
    props: {
        html: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        truncated: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        contentClasses() {
            const cls = {};
            cls['max-w-2xl'] = true;
            cls['text-sm font-normal tracking-tight sm:text-base'] = true;
            cls[this.contentColor] = true;
            cls['truncate'] = !!this.truncated;
            cls['text-center mx-auto'] = !!this.textCentered;
            return cls;
        },
    },
};
</script>
